import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_hdnia0q";
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID ||  "template_7eva9cq";
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "WK_3SacTDGCKivJ8I";

export default function Contact() {
  const formRef = useRef(null);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
      setStatus({
        type: "error",
        message: "Email service is not configured. Please try again later.",
      });
      return;
    }

    setSending(true);

    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
      .then(
        () => {
          setStatus({
            type: "success",
            message: "Message sent successfully. I’ll get back to you soon.",
          });
          formRef.current?.reset();
        },
        (err) => {
          console.error("EmailJS error:", err);
          setStatus({
            type: "error",
            message: "Something went wrong. Please try again.",
          });
        }
      )
      .finally(() => setSending(false));
  };

  return (
    <section id="contact" className="section contactPro">
      <div className="container">
        <div className="sectionHeader">
          <h2 className="sectionTitle">Contact</h2>
          <p className="sectionSubtitle">
            Hiring, contract work, or collaboration—send a message and I’ll respond quickly.
          </p>
        </div>

        <div className="contactPro__card">
          {/* LEFT: Info */}
          <aside className="contactPro__aside" aria-label="Contact information">
            <div className="contactPro__asideHeader">
              <h3 className="contactPro__asideTitle">Let’s connect</h3>
              <p className="contactPro__asideText">
                Prefer email or LinkedIn? Use whatever is easiest.
              </p>
            </div>

            <div className="contactPro__info">
              {/* <a className="contactPro__infoRow" href="tel:+16466730832">
                <span className="contactPro__icon" aria-hidden="true">☎</span>
                <span>
                  <span className="contactPro__label">Phone</span>
                  <span className="contactPro__value">+1 (646) 673-0832</span>
                </span>
              </a> */}

              <a className="contactPro__infoRow" href="mailto:issoufzabre226@gmail.com">
                <span className="contactPro__icon" aria-hidden="true">✉</span>
                <span>
                  <span className="contactPro__label">Email</span>
                  <span className="contactPro__value">issoufzabre226@gmail.com</span>
                </span>
              </a>
            </div>

            <div className="contactPro__links">
              <a
                className="btn btn--ghost contactPro__linkBtn"
                href="https://www.linkedin.com/in/zabreissouf/"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>

              <a
                className="btn btn--ghost contactPro__linkBtn"
                href="https://github.com/zabroski"
                target="_blank"
                rel="noreferrer"
              >
                GitHub
              </a>
            </div>

            <div className="contactPro__note">
              <span className="contactPro__noteDot" aria-hidden="true" />
              Available for React / Front-End roles in NYC and remote.
            </div>
          </aside>

          {/* RIGHT: Form */}
          <div className="contactPro__main">
            <form ref={formRef} className="contactPro__form" onSubmit={handleSubmit}>
              <div className="contactPro__grid">
                <div className="contactPro__field">
                  <label htmlFor="from_name">Name</label>
                  <input
                    id="from_name"
                    name="from_name"
                    type="text"
                    placeholder=""
                    autoComplete="name"
                    required
                  />
                </div>

                <div className="contactPro__field">
                  <label htmlFor="reply_to">Email</label>
                  <input
                    id="reply_to"
                    name="reply_to"
                    type="email"
                    placeholder=""
                    autoComplete="email"
                    required
                  />
                </div>
              </div>

              <div className="contactPro__field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  placeholder=""
                  required
                />
              </div>

              {status.message && (
                <div
                  className={`contactPro__status ${
                    status.type === "success" ? "contactPro__status--success" : "contactPro__status--error"
                  }`}
                  role="status"
                  aria-live="polite"
                >
                  {status.type === "success" ? (
                    <span className="contactPro__statusIcon contactPro__statusIcon--success" aria-hidden="true">
                      ✓
                    </span>
                  ) : (
                    <span className="contactPro__statusIcon contactPro__statusIcon--error" aria-hidden="true">
                      !
                    </span>
                  )}
                  <span>{status.message}</span>
                </div>
              )}

              <div className="contactPro__actions">
                <button type="submit" className="btn btn--primary" disabled={sending}>
                  {sending ? "Sending..." : "Send message"}
                </button>

                <span className="contactPro__hint">
                  Typically replies within 24–48 hours.
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
